import { AvailableLanguages } from '@repo/toolkit/language-types'
import { Column } from '@repo/ui/data-table'
import { TFunction } from 'i18next'

import { MobileNumberForFrenchLeader } from '../../../lib/types/models/ol/mobile-number-for-french-leader/mobile-number-for-french-leader'
import { formatPhoneNumber } from '../../../utils/functions/format-phone-number'

export const mobileNumberForFrenchLeadersColumns = (
  t: TFunction<AvailableLanguages, undefined>
): Column<MobileNumberForFrenchLeader>[] => [
  {
    accessorKey: 'phoneNumber',
    columnHeaderClassName: 'w-1/2',
    header: t('mobile.number.for.french.leaders.table.phoneNumber'),
    cell: ({ row }) => formatPhoneNumber(row.original.phoneNumber)
  }
]

export const getMobileNumberForFrenchLeadersColumns = (
  t: TFunction<AvailableLanguages, undefined>
): Column<MobileNumberForFrenchLeader>[] => {
  return mobileNumberForFrenchLeadersColumns(t)
}
